import React from 'react';
import ReactDOM from 'react-dom';

import Iconset from './icons';
import Clipboard from 'clipboard';

//styles
import '../styles/share.scss';

const fbInfo = [
	{
		image : 'http://blossomentary.milkychance.net/thumbnail/thumbnail-chapter1.png',
		content : "Enjoy an interactive live performance from Milky Chance’s new song Doing Good and pre-order the new album Blossom.",
	},
	{
		image : 'http://blossomentary.milkychance.net/thumbnail/thumbnail-chapter2.png',
		content : "Find out what brought Clemens and Philipp together, how they create music and what’s behind their upcoming album BLOSSOM!",
	},
	{
		image : 'http://blossomentary.milkychance.net/thumbnail/thumbnail-chapter3.png',
		content : "Check out the 3rd part of our interactive journey! Create your own version of the album cover and get more insights on the new tracks day by day.",
	}
]

class Shareelement extends React.Component{

	constructor(props){
		super(props);

		this.state={
			activeMenu : false,
			copySuccess : false,
			copyError : false,
			currentChapter : 2
		}

		this.copyButton = null;
		this.clipBoard = null;

		this.toggleShareMenu = this.toggleShareMenu.bind(this);
		
	}

	componentDidMount(){

		if(!_assets.isMobile){
			this.prepareClipBoard();
		}

		if(this.props.chapter != "home"){
			this.setState({
				currentChapter : this.props.chapter - 1
			},()=>{

				document.querySelector('meta[name="twitter:image"]').setAttribute("content",fbInfo[this.state.currentChapter].image);
				document.querySelector('meta[name="og:image"]').setAttribute("content",fbInfo[this.state.currentChapter].image);

				document.querySelector('meta[name="twitter:card"]').setAttribute("content",fbInfo[this.state.currentChapter].content);
				document.querySelector('meta[name="twitter:description"]').setAttribute("content",fbInfo[this.state.currentChapter].content);
				document.querySelector('meta[property="og:description"]').setAttribute("content",fbInfo[this.state.currentChapter].content);
				document.querySelector('meta[name="description"]').setAttribute("content",fbInfo[this.state.currentChapter].content);


			});
		}else{

		}

		
	}

	toggleShareMenu(){
		this.setState({
			activeMenu : !this.state.activeMenu
		});
	}

	shareOnTwitter(e){
		e.preventDefault();
    window.open("https://twitter.com/home?status=http%3A//blossomentary.milkychance.net%20-%20The%20interactive%20documentary%20-%20Find%20out%20what’s%20behind%20Milky%20Chance's%20new%20album%20BLOSSOM!", "Twitter", "height=670,width=400,resizable=1");

	}
	shareOnFacebook(e){
		e.preventDefault();

		console.log(fbInfo, this.state.currentChapter);

		FB.ui({
	    method: 'share',
	    href: 'http://blossomentary.milkychance.net',
	    picture: fbInfo[this.state.currentChapter].image,
	    title: "Milky Chance • A Blossomentary",
	    description: fbInfo[this.state.currentChapter].content,
	    caption: "Milky Chance • A Blossomentary"
	   }, function(response) {});

	}


	prepareClipBoard(){
		this.clipBoard = new Clipboard(this.copyButton, {
		    text: function(trigger) {
		        return "http://blossomentary.milkychance.net";
		    }
			});

			this.clipBoard.on('success', function(e) {
				console.log('copy to clipboard: success');
		    this.setState({
		    	copySuccess : true
		    });
		    this.resetCopyCode();
		    e.clearSelection();
			}.bind(this));

			this.clipBoard.on('error', function(e) {
				console.log('copy to clipboard: error');
				this.setState({
		    	copyError : true
		    });
		    this.resetCopyCode();
			});

			
	}

	resetCopyCode(){
		setTimeout(function(){
				this.setState({
					copySuccess : false,
					copyError : false
				});
			}.bind(this),2000);
	}



	render(){
		return (
			<div className="flex-box share-holder">
				<button className="share-button" onClick={ this.toggleShareMenu }>
					<Iconset.share/>
				</button>
				<div className={"share-menu share-menu-" + this.state.activeMenu} >
					<div className="share-icon-set">
						<div className="share-icon">
							<button name="Twitter" onClick={this.shareOnTwitter} ><Iconset.twitter /></button>
						</div>
						{ !_assets.isMobile &&  
							<div className="share-icon">
								{(this.state.copySuccess || this.state.copyError) && 
									<div className="copy-notification">
										{(this.state.copySuccess) && 
										<span>Copied to clipboard</span>
										}
										{this.state.copyError && 
										<span className="copy-notification-error">Ups! Cannot copy to clipboard</span>
										}
									</div>
								}
								<button name="copy" ref={(copyButton)=>{this.copyButton = copyButton; }}><Iconset.copy /></button>
							</div>
						}
						<div className="share-icon">
							<button name="Facebook" onClick={(event)=>this.shareOnFacebook(event)}><Iconset.facebook /></button>
						</div>
					</div>
				</div>
			</div>);
	}
}

export default Shareelement;


// WEBPACK FOOTER //
// ./src/scripts/shareelement.js